import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { JobFair } from 'app/types';
import { useAppContext } from 'app/context/app-context';
import { JobfairService } from 'app/services/JobfairService';
import { useAuth } from 'app/context/auth-context';
import Select from 'react-select'
import { useParams } from 'react-router-dom';
import { KTSVG } from '../../../helpers';
import { config } from 'config';

const JobFairSelector: React.FC = () => {
    const { jobFair, setJobFair } = useAppContext();
    const [jobFairs, setJobFairs] = useState<JobFair[]>([]);
    const jobfairService = new JobfairService();
    const { user } = useAuth();
    const params = useParams<{ orgId: string, jobFairId: string }>();


    useEffect(() => {
        const fetchJobFairs = async () => {
            if (!user?.organizationId) return;
            const fetchedJobFairs = await jobfairService.getJobFairs(user?.organizationId);
            if (fetchedJobFairs.length === 0) {
                setJobFair(null);
            }
            else
                setJobFairs(fetchedJobFairs);
        };
        fetchJobFairs();
    }, []);

    useEffect(() => {
        if (jobFairs.length == 0)
            return;
        const now = new Date(new Date().toDateString());
        const sortedAsc = [...jobFairs].sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
        const nextJobFair = sortedAsc.find(jf => new Date(jf.startDate) > now);
        setJobFair(nextJobFair || sortedAsc[sortedAsc.length - 1]);
    }, [jobFairs]);

    return (
        <div className="d-flex align-items-center">
            <div className="btn btn-icon btn-active-light-primary position-relative w-30px h-30px w-md-40px h-md-40px me-3">
                <i className="ki-duotone ki-calendar fs-1">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>
            </div>
            {jobFairs.length > 0 ? (
                <div className='input-group input-group-solid flex-nowrap'>
                    <span className="input-group-text">
                    </span>
                    <div className='flex-grow-1'>
                        <Select
                            classNames={{
                                control: () => ('rounded-start-0'),
                            }}
                            className='react-select-styled react-select-solid'
                            classNamePrefix='react-select'
                            value={{ value: jobFair?.id, label: jobFair ? `${jobFair.name} (${moment(jobFair.startDate).format('DD MMM YYYY')})` : '' }}
                            onChange={(selected) => {
                                const selectedJobFair = jobFairs.find(jf => jf.id === selected?.value);
                                if (selectedJobFair) setJobFair(selectedJobFair);
                            }}
                            options={jobFairs.map((jobFair) => {
                                return { value: jobFair.id, label: `${jobFair.name} (${moment(jobFair.startDate).format('DD MMM YYYY')})` };
                            })}
                            placeholder='Select a job fair'
                        />
                    </div>
                    <span className='input-group-text cursor-pointer d-flex align-items-center' title="Copy Job Seeker On-boarding URL" onClick={() => {
                        navigator.clipboard.writeText(`${config.vjfpBaseUrl}${jobFair?.alias ? `join/${jobFair?.alias}` : `job-seeker/organizations/${jobFair?.companyId}/jobfairs/${jobFair?.id}`}`);
                        const label = document.getElementById(`copy-label-${jobFair?.id}`);
                        label!.classList.remove('d-none');
                        setTimeout(() => label!.classList.add('d-none'), 2000);
                    }}>
                        <KTSVG path='/media/icons/duotone/General/Copy.svg' className='svg-icon-2' />
                        <span id={`copy-label-${jobFair?.id}`} className='ms-2 text-success fw-bold d-none'>Copied!</span>
                    </span>
                </div>
            ) : (
                <span className="badge badge-light-warning fs-7 fw-bold">No Job Fairs</span>
            )}
        </div>
    );
};

export default JobFairSelector;
